// extracted by mini-css-extract-plugin
export default {"container":"ModularConfiguratorActions__container___B7Te8","buttonAddToCart":"ModularConfiguratorActions__buttonAddToCart___lKHNQ"};